export default "__VITE_ASSET__BnEBO_R0__"